module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"all":"All","filter":"Filter","drafts":"Drafts","published":"Published","publishedWithChanges":"Unpublished changes"}}')
  delete Component.options._Ctor
}
